export default __webpack_public_path__ + "static/media/rotate-icon.1357f604.svg";